'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Chapter from 'academy-shared-js/records/Chapter';
import { getContentById } from '../../selectors/contentSelectors';
import ChapterContent from '../../components/Chapter/ChapterContent';
import UsageTracker from '../../utils/UsageTracker';
import { TrackingContentTypes } from '../../constants/Tracking';
import { updateContentProgress } from '../../features/userProgress';

class ChapterContainer extends Component {
  constructor(props) {
    super(props);
    this.handleComplete = this.handleComplete.bind(this);
  }

  handleComplete() {
    const {
      chapter,
      contentId,
      trackId,
      lessonId
    } = this.props;
    updateContentProgress({
      contentId: Number(contentId),
      trackId: Number(trackId),
      lessonId: Number(lessonId),
      language: chapter.get('language')
    });
    UsageTracker.track('contentProgress', {
      action: 'complete-chapter',
      contentId,
      contentLanguage: chapter.get('language'),
      contentType: TrackingContentTypes.CHAPTER,
      trackId,
      lessonId
    });
  }

  render() {
    const {
      chapter,
      onFinish
    } = this.props;
    const {
      contentId,
      trackId,
      lessonId
    } = this.props;
    return /*#__PURE__*/_jsx(ChapterContent, {
      advanceToNextContent: onFinish,
      completed: chapter.get('completed'),
      contentId: contentId,
      contentLanguage: chapter.get('language'),
      contents: chapter.get('contents'),
      error: chapter.get('contentError'),
      isLoading: chapter.get('isLoadingContents'),
      lessonId: lessonId,
      name: chapter.get('name'),
      onComplete: this.handleComplete,
      trackId: trackId
    });
  }

}

ChapterContainer.propTypes = {
  chapter: PropTypes.instanceOf(Chapter).isRequired,
  contentId: PropTypes.string.isRequired,
  lessonId: PropTypes.string.isRequired,
  onFinish: PropTypes.func,
  trackId: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  const chapter = getContentById(state, ownProps.contentId);
  return {
    chapter
  };
}

export default connect(mapStateToProps)(ChapterContainer);